import { actions, initialSysAppLoggerState } from "./action";

export const sysAppLoggerReducer = (state = initialSysAppLoggerState, action) => {
    switch (action.type) {
        case actions.SYSAPPLOGGER_GET_ALL_SUCCESS:
            return {
                ...state,
                sysAppLoggerList: action.payload ? action.payload : {}
            };
        case actions.SYSAPPLOGGER_UPDATE_SUCCESS:
            return {
                ...state,
                sysAppLogger: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.SYSAPPLOGGER_CREATE_SUCCESS:
            return {
                ...state,
                sysAppLogger: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.SYSAPPLOGGER_DELETE_SUCCESS:
            return {
                ...state,
                sysAppLogger: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.SYSAPPLOGGER_RESET_SUCCESS:
            return {
                ...state,
                sysAppLogger: {},
                filters: {}
            };
        case actions.SYSAPPLOGGER_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload || {}
            };
        default:
            return state;
    }
};
